const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/raw-footage/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { requireCapabilities } from '@/features/authentication/lib/routeGuards';
import { createFileRoute } from '@tanstack/react-router';

/**
 * Layout route for the `/raw-footage` section: the org/project picker as a
 * secondary rail beside the section's pages (the primary nav stays in
 * `AppLayout`). `SectionShell` turns the rail into the mobile root selection
 * page while keeping the desktop two-rail layout.
 */
export const Route = createFileRoute('/_authenticated/_app/raw-footage')({
  beforeLoad: requireCapabilities(has => has('assets.list') || has('submissions.list')),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});